import getGlobalSettingsAccountMailboxInfo from 'owa-account-source-list-store/lib/selectors/getGlobalSettingsAccountMailboxInfo';
import { logUsage } from 'owa-analytics';
import type { OwaHeaderButtonClickSource } from 'owa-header-types';

/**
 * Logs a usage event whenever a header button is clicked, regardless of whether it
 * was clicked directly in the header or through the overflow menu. The button id is
 * included in the custom data so we can track which buttons are used most frequently.
 */
export default function logHeaderButtonClick(
    buttonId: string,
    source: OwaHeaderButtonClickSource
): void {
    logUsage('HeaderButtonClicked', getGlobalSettingsAccountMailboxInfo(), {
        buttonId,
        source,
    });
}
